export enum EisAsyncSendStatus {
    None = 'None',
    InProgress = 'InProgress',
    Error = 'Error',
    Success = 'Success',
    Queued = 'Queued',
}
